// A dead link (Console D entry screens, APS-323): what happened, and the way back.
import { Link } from '@tanstack/react-router'
import { EntryHead, EntryPage } from '../components/d'
import { useI18n } from '../i18n'

export function NotFoundPage() {
  const { t } = useI18n()
  return (
    <EntryPage>
      <EntryHead
        kicker={t('notFound.kicker')}
        title={t('notFound.title')}
        lede={t('notFound.body')}
      />
      <div className="en-acts">
        <Link to="/" className="btn solid en-full">
          {t('notFound.home')}
        </Link>
      </div>
    </EntryPage>
  )
}
